/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import React, { useMemo } from 'react';
import Link from 'next/link';
import Image from 'next/image';

import { useAppSelector } from '@/hooks/useRedux';
import { imageSrc } from '@/utils/asset';
import { getRuntimeOrg } from '@/utils/runtimeOrg';
import { getOrgMetaClient } from '@/config/client';

type LogoProps = {
  href?: string;
  width?: number;
  height?: number;
  className?: string;
  imgClassName?: string;
  priority?: boolean;
};

export default function Logo({
  href = '/',
  width = 256,
  height = 75,
  className = '',
  imgClassName = '',
  priority = true,
}: LogoProps) {
  const cfg = useAppSelector((s: any) => s?.config?.org);

  const alt = cfg?.name || 'Home';

  const src = useMemo(() => {
    const fallback = getOrgMetaClient(getRuntimeOrg()).logo;
    return imageSrc(cfg?.logo || fallback || '/logo.svg');
  }, [cfg?.logo]);

  return (
    <div
      className={`
        flex items-center
        w-full flex-shrink-0
        ${className}
      `}
    >
      <Link href={href} aria-label={alt} className="block w-full">
        <Image
          src={src}
          alt={alt}
          width={width}
          height={height}
          priority={priority}
          className={`w-full h-auto object-contain ${imgClassName}`}
        />
      </Link>
    </div>
  );
}
